// 비밀번호 규칙 한 벌 — 초대 수락(서버)과 새 비밀번호 화면(브라우저)이 같이 쓴다 · Supabase 대시보드 최소 길이도 8자로 맞춘다.

import { z } from "zod";

export const PASSWORD_MIN = 8;
export const PASSWORD_MAX = 200;
export const PASSWORD_MISMATCH_TEXT = "두 비밀번호가 다릅니다";

export const passwordField = z
  .string()
  .min(PASSWORD_MIN, { message: `비밀번호는 ${PASSWORD_MIN}자 이상이어야 합니다` })
  .max(PASSWORD_MAX, { message: "비밀번호가 너무 깁니다" });

// 새 비밀번호 두 칸 — 문제가 있으면 첫 문구, 없으면 null.
export const newPasswordIssue = (password: string, confirm: string): string | null => {
  const parsed = passwordField.safeParse(password);
  if (!parsed.success) return parsed.error.issues[0]?.message ?? "비밀번호를 확인하세요";
  return password === confirm ? null : PASSWORD_MISMATCH_TEXT;
};
